import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { getLabel } from 'utils/getLabel';

//widget view
import { ToDoItemDetailSummaryWidget } from 'ui/containers/ToDoItemDetailSummaryWidget';
import { ToDoItemDetailActivityWidget } from 'ui/containers/ToDoItemDetailActivityWidget';

const WIDGET_VIEWS = {
    [ WIDGET_NAMES.TO_DO_DETAIL_SUMMARY ]: ToDoItemDetailSummaryWidget,
    [ WIDGET_NAMES.TO_DO_DETAIL_ACTIVITY ]: ToDoItemDetailActivityWidget,
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { toDoItemDetailWidget as ToDoItemDetailWidget } from 'ui/views/toDoItemDetailWidget';
 *
 * // render
 * <ToDoItemDetailWidget propName='propValue'/>
 */
export const toDoItemDetailWidget = ( props ) => {
    return (
        <div className='ui-to-do-item-detail-widget'>
            <div className='ui-to-do-item-detail-widget__action'>
                {
                    map( props.navActions, navAction => {

                        // get the action for navAction
                        const icondId = 'back' === navAction.name ? 'backArrow': null;

                        return (
                            <div className='ui-to-do-item-detail-widget__action__navaction' key={ navAction.name }
                                onClick={ () => props.onNavActionClick( { type: 'headerAction', value: navAction } ) }
                            >
                                <Icon id={ icondId } />
                                <div className='ui-to-do-item-detail-widget__action__navaction__label'>{ getLabel( navAction.title ) }</div>
                            </div>
                        );

                    } )
                }
            </div>

            <div className='ui-to-do-item-detail-widget__widgets'>
                {
                    map( props.widgets, ( widget, widgetIndex ) => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        const widgetClassName = classnames( 'ui-to-do-item-detail-widget__widgets__widget', `ui-to-do-item-detail-widget__widgets__widget--name-${ widget.name }` );
    
                        return (
                            <div key={ widgetIndex } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    taskId={ props.taskId }
                                    requestPayload={ props.requestPayload }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>

        </div>
    );
};

// set display name
toDoItemDetailWidget.displayName = 'toDoItemDetailWidget';

// set default props
toDoItemDetailWidget.defaultProps = {};

// prop types
toDoItemDetailWidget.propTypes = {};

// preloader view
export const toDoItemDetailWidgetPreloader = () => {
    return (
        <div className='ui-to-do-item-detail-widget-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
toDoItemDetailWidgetPreloader.displayName = 'toDoItemDetailWidgetPreloader';

// set default props
toDoItemDetailWidgetPreloader.defaultProps = {};

// prop types
toDoItemDetailWidgetPreloader.propTypes = {};

export const toDoItemDetailWidgetView = withNetworkState( toDoItemDetailWidgetPreloader, toDoItemDetailWidget );
